import { Typography } from '@mui/material';

import { TooltipTypography } from '~/components/TooltipTypography/TooltipTypography';

interface HeaderCellProps {
  title: string;
  subTitle: string;
}

export const HeaderCell = ({ title, subTitle }: HeaderCellProps) => {
  return (
    <>
      <TooltipTypography title={title}>
        <Typography component="div" variant="subtitle2" noWrap>
          {title}
        </Typography>
      </TooltipTypography>
      <Typography
        component="div"
        variant="caption"
        noWrap
        sx={{
          color: 'text.secondary',
        }}
      >
        {subTitle}
      </Typography>
    </>
  );
};
